import { AuthApi, ClientApi, UsersApi, WorkbookApi } from "./requests";
import { store as uiStore } from "./store/ui";

const api: {
    authApi: AuthApi | null;
    userApi: UsersApi | null;
    clientApi: ClientApi | null;
    workbookApi: WorkbookApi | null;
} = {
    authApi: null,
    userApi: null,
    clientApi: null,
    workbookApi: null
};

const reloadApi = (): void => {
    api.authApi = new AuthApi({
        basePath: uiStore.apiPath
    });
    api.userApi = new UsersApi({
        basePath: uiStore.apiPath
    });
    api.clientApi = new ClientApi({
        basePath: uiStore.apiPath
    });
    api.workbookApi = new WorkbookApi({
        basePath: uiStore.apiPath
    });
};

export { api, reloadApi };
